module.exports = __webpack_public_path__ + "img/P11b_Ainsworth Dyer.e46a20e6.jpg";